/**
 * La matricola di una macchina, come va letta da un essere umano.
 *
 * Sempre in maiuscolo. Non e' un vezzo tipografico: quella stringa viene
 * confrontata a voce con l'assistenza e a occhio con la targhetta sulla
 * macchina, dove e' stampata in maiuscolo. Vederla scritta `a001` in un punto e
 * `A001` in un altro costringe chi guarda a chiedersi se siano la stessa cosa -
 * e per una riga che esiste solo per essere confrontata, e' il difetto peggiore
 * che possa avere.
 *
 * La trasformazione e' solo di presentazione: il valore resta quello che la
 * macchina ha scritto, e le ricerche continuano a confrontare in minuscolo.
 */
export function formatSerial(value: string | null | undefined): string {
  return (value ?? '').trim().toUpperCase();
}
